import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { IPartnerRatingByPartner } from '../interfaces';
import { getPartnerRatingByPartner } from '../api';

export function useGetPartnerRatingByPartner() {
  const [{ loading, data, error, success }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, IPartnerRatingByPartner>;
    success: boolean;
  }>({ loading: false, error: null, data: new Map(), success: false });

  const fetchPartnerRatingByPartner = async (partnerGuid: string, config: AxiosRequestConfig) => {
    const mapKey = Object.values(Object.assign({ partnerGuid }, config.params)).filter(Boolean).join('-');
    if (data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true, success: false }));

    try {
      const response = await getPartnerRatingByPartner(partnerGuid, config);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData, success: true };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, success, fetchPartnerRatingByPartner };
}
